import { UNUSUAL_TEXT } from "./constants";

import { UNUSUAL_TEXT_KEY } from "./constants";

export const UnusualH1 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h1 {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })} {...props}>
            {children}
        </h1>
    );
};

export const UnusualH2 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h2 {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })} {...props}>
            {children}
        </h2>
    );
};

export const UnusualH3 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h3 {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })} {...props}>
            {children}
        </h3>
    );
};

export const UnusualH4 = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLHeadingElement>) => {
    return (
        <h4 {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })} {...props}>
            {children}
        </h4>
    );
};

export const UnusualP = ({
    children,
    unusualKey,
    additional,
    ...props
}: {
    children: React.ReactNode;
    unusualKey?: UNUSUAL_TEXT_KEY;
    additional?: string;
} & React.HTMLAttributes<HTMLParagraphElement>) => {
    return (
        <p {...(unusualKey && { "unusual-id": `${UNUSUAL_TEXT[unusualKey].TITLE}-${additional}` })} {...props}>
            {children}
        </p>
    );
};
